import SEO from "../components/SEO";
import VideoShowcase from "../components/VideoShowcase";
import Contact from "../components/Contact";
import IntelligenceLanding from "../components/IntelligenceLanding";
import { LEGAL_NAME } from "../config/branding";

export default function Home() {
  return (
    <>
      <SEO
        title={`${LEGAL_NAME} | AI Engineering Partner for Smarter Operations`}
        description={`${LEGAL_NAME} helps businesses, teams, and institutions build AI-powered products, systems, automation, and always-on support that drive growth around the clock.`}
        url="https://www.jisedai.africa"
      />
      <IntelligenceLanding />
      <VideoShowcase />
      <Contact />
    </>
  );
}
